const PREFIX = "HEALO_";

export const getItem = key => window.localStorage.getItem(`${PREFIX}${key}`);
export const setItem = (key, value) =>
  window.localStorage.setItem(`${PREFIX}${key}`, value);



// WEBPACK FOOTER //
// ./src/modules/local-storage/local-storage-effects.js